<template>
  <div class="control">
    <div class="control__action">
      <div class="control__choice">
        <div
          class="fakeoverlay"
          :class="{ disabled: !widgetStatus }"
          @click="widgetStatus = true"
        />
        <div class="subtitle">Buttons</div>
        <div v-for="(button, index) in buttonsList" :key="button.value" class="sub-checkboxes">
          <el-checkbox
            v-model="selectedButtons[index]"
            :disabled="button.value === 'play' || button.value === 'pause' || !widgetStatus"
            :checked="button.value === 'play' || selectedButtons.includes(button.value)"
            :class="{
              undisabled: (button.value === 'play' || button.value === 'pause') && widgetStatus,
            }"
            @change="changeSpinControlPanelSettings"
          >
            {{ button.label }}
          </el-checkbox>
        </div>
        <div class="subtitle">Position</div>
        <div v-for="position in positionsList" :key="position.value" class="sub-radio">
          <el-radio
            v-model="selectedPosition"
            :disabled="!widgetStatus"
            :label="position.value"
            @change="changeSpinControlPanelSettings"
          >
            {{ position.label }}
          </el-radio>
        </div>
        <div class="subtitle">Icon style</div>
        <div v-for="icon in iconsStyleList" :key="icon.value" class="sub-radio">
          <el-radio
            v-model="selectedIconsStyle"
            :disabled="!widgetStatus"
            :label="icon.value"
            @change="changeSpinControlPanelSettings"
          >
            {{ icon.label }}
          </el-radio>
        </div>
        <div class="subtitle">Background color</div>
        <el-color-picker
          v-model="background"
          show-alpha
          class="colorpicker"
          :disabled="!widgetStatus"
          @change="changeSpinControlPanelSettings"
        />
        <div class="subtitle">Icon color</div>
        <el-color-picker
          v-model="color"
          show-alpha
          class="colorpicker"
          :disabled="!widgetStatus"
          @change="changeSpinControlPanelSettings"
        />
        <div class="subtitle">Icon size</div>
        <div>
          <el-slider
            v-model="size"
            :min="12"
            :max="100"
            :class="{ disabled: !widgetStatus }"
            :disabled="!widgetStatus"
            @change="changeSpinControlPanelSettings"
          />
        </div>
      </div>
      <el-checkbox
        v-model="widgetStatus"
        class="control__checkbox"
        @change="changeSpinControlPanelSettings"
      />
    </div>
  </div>
</template>

<script>
import { hintOptionMixin } from "@/mixins/hintOption.mixin";
import spinControlButtons from "@/assets/spin_control_buttons.json";
import spinControlPosition from "@/assets/spin_control_position.json";
import spinControlIconsStyle from "@/assets/spin_control_icon_style.json";
import { mapGetters, mapState } from "vuex";
export default {
  name: "SpinControlPanel",
  mixins: [hintOptionMixin],
  props: {
    title: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      default: "",
    },
    status: {
      type: Boolean,
    },
    parameter: {
      type: String,
      default: "",
    },
    defaultButtons: {
      type: Array,
      default: () => [true],
    },
    defaultIcons: {
      type: String,
      default: "flat",
    },
    defaultPosition: {
      type: String,
      default: "onspin",
    },
    eventClick: {
      type: Boolean,
      default: false,
    },
    defaultBackground: {
      type: String,
    },
    defaultColor: {
      type: String,
    },
    iconsSize: {
      type: Number,
      default: 30,
    },
  },
  data() {
    return {
      buttonsList: spinControlButtons,
      positionsList: spinControlPosition,
      iconsStyleList: spinControlIconsStyle,
      selectedButtons: this.defaultButtons,
      selectedPosition: this.defaultPosition,
      selectedIconsStyle: this.defaultIcons,
      background: this.defaultBackground,
      color: this.defaultColor,
      size: this.iconsSize,
      widgetStatus: this.status,
    };
  },
  computed: {
    ...mapState(["clearOptions"]),
    ...mapGetters({
      spinControlPanelStatus: "spinControl/spinControlPanelStatus",
      spinControlModalStatus: "spinControl/spinControlModalStatus",
      spinControlModalApprove: "spinControl/spinControlModalApprove",
      getSpinAssets: "getSpinAssets",
      getImageAssets: "getImageAssets",
      getVideoAssets: "getVideoAssets",
      getViewAssets: "getViewAssets",
      getModelAssets: "getModelAssets",
      getPanoramaAssets: "getPanoramaAssets",
    }),
  },
  watch: {
    defaultButtons(val) {
      let indexes = [];
      spinControlButtons.forEach((b, i) => {
        if (val.includes(b.value)) {
          indexes.push(i);
        }
      });
      indexes.forEach((e) => {
        this.selectedButtons[e] = true;
      });
    },
    defaultPosition(val) {
      this.selectedPosition = val;
    },
    defaultIcons(val) {
      this.selectedIconsStyle = val;
    },
    defaultBackground(val) {
      this.background = val;
    },
    defaultColor(val) {
      this.color = val;
    },
    iconsSize(val) {
      this.size = val;
    },
    eventClick(val) {
      if (val) {
        this.widgetStatus = true;
        const markedSpins = this.getSpinAssets.filter((s) => s.added);

        if (markedSpins.length > 1) {
          this.$store.dispatch("spinControl/changeSpinControlModalStatus", true);
        } else {
          this.$store.dispatch("spinControl/changeSpinControlModalApprove", true);
          this.changeSpinControlPanelSettings();
        }
      }
    },
    clearOptions() {
      this.widgetStatus = false;
      this.$store.dispatch("spinControl/changeSpinControlModalApprove", false);
      this.changeSpinControlPanelSettings();
    },
    status(val) {
      this.widgetStatus = val;
    },
    widgetStatus(val) {
      const markedSpins = this.getSpinAssets.filter((s) => s.added);
      const markedImages = this.getImageAssets.filter((i) => i.added);
      const markedVideos = this.getVideoAssets.filter((v) => v.added);
      const markedViews = this.getViewAssets.filter((v) => v.added);
      const markedModel = this.getModelAssets.filter((m) => m.added);
      const markedPanorama = this.getPanoramaAssets.filter((m) => m.added);

      if (
        (val && markedSpins.length > 1) ||
        markedImages.length ||
        markedVideos.length ||
        markedViews.lengths ||
        markedModel.lengths ||
        markedPanorama.lengths
      ) {
        this.$store.dispatch("spinControl/changeSpinControlModalStatus", true);
      }
      this.changeSpinControlPanelSettings();
    },
    spinControlPanelStatus(val) {
      if (val === false) {
        this.widgetStatus = false;
      }
    },
    spinControlModalStatus(val) {
      if (!val && !this.spinControlModalApprove) {
        this.widgetStatus = false;
        this.$store.dispatch("spinControl/changeSpinControlPanelSettings", {
          status: this.widgetStatus,
        });
      }

      if (!val && this.spinControlModalApprove) {
        this.widgetStatus = true;
        this.changeSpinControlPanelSettings();
      }
    },
    spinControlModalApprove(val) {
      if (val) {
        this.changeSpinControlPanelSettings();
      } else {
        this.$store.dispatch("spinControl/changeSpinControlModalApprove", false);
        this.widgetStatus = false;
        this.changeSpinControlPanelSettings();
      }
    },
  },
  methods: {
    changeSpinControlPanelSettings() {
      const formattedSelectedButtons = [];
      this.selectedButtons.forEach((e, index) => {
        if (e === true) {
          formattedSelectedButtons.push(spinControlButtons[index].value);
        }
      });
      // TODO current functionality allow use only one spin. But in the next step we should improve this widget to multi spin mode.
      if (this.widgetStatus && this.spinControlModalApprove) {
        this.$store.dispatch("enableOnlyOneSpin");
      }
      /*
       * Current widget don't use normal flow of changing options. It change self module in the store.
       */
      this.$store.dispatch("spinControl/changeSpinControlPanelSettings", {
        selectedButtons: formattedSelectedButtons,
        selectedPosition: this.selectedPosition,
        selectedIconsStyle: this.selectedIconsStyle,
        background: this.background,
        color: this.color,
        size: this.size,
        status: this.widgetStatus,
      });
      this.$store.dispatch("spinControl/changeSpinControlModalApprove", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.subtitle {
  color: #6c7683;
  margin-top: 5px;
}
.sub-checkboxes {
  display: flex;
  align-items: center;
}

.undisabled::v-deep .el-checkbox__label {
  color: #409eff !important;
}

.undisabled::v-deep .el-checkbox__inner::after {
  border-color: #409eff !important;
}
.el-slider__runway.disabled {
  z-index: 2;
}
</style>
